import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const state: Store.LiveSocial.State = {
  general: {
    description: '',
    madeForKids: false,
    privacyStatus: 'public',
    title: '',
  },
  youtubeLivestreamUserSettings: {
    userId: '',
    email: '',
    name: '',
    socialId: '',
    idCustomerPlans: 0,
    idCustomerPlansEvents: 0,
  },
  providers: {
    custom: [],
    facebook: [],
    instagram: [],
    twitch: [],
    twitter: [],
    youtube: [],
  },
};

const namespaced = true;

export const liveSocial: Module<Store.LiveSocial.State, RootState> = {
  actions,
  getters,
  mutations,
  namespaced,
  state,
};
